<template>
  <div
    class="circle-loader"
    :class="[size]"
  >
    <!--<svg
      version="1.1"
      class="svg-loader"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 80 80"
      xml:space="preserve"
    >
      <path
        d="M10,40c0,0,0-0.4,0-1.1c0-0.3,0-0.8,0-1.3c0-0.3,0-0.5,0-0.8c0-0.3,0.1-0.6,0.1-0.9c0.1-0.6,0.1-1.4,0.2-2.1
	c0.2-0.8,0.3-1.6,0.5-2.5c0.2-0.9,0.6-1.8,0.8-2.8c0.3-1,0.8-1.9,1.2-3c0.5-1,1.1-2,1.7-3.1c0.7-1,1.4-2.1,2.2-3.1
	c1.6-2.1,3.7-3.9,6-5.6c2.3-1.7,5-3,7.9-4.1c0.7-0.2,1.5-0.4,2.2-0.7c0.7-0.3,1.5-0.3,2.3-0.5c0.8-0.2,1.5-0.3,2.3-0.4l1.2-0.1
	l0.6-0.1l0.3,0l0.1,0l0.1,0l0,0c0.1,0-0.1,0,0.1,0c1.5,0,2.9-0.1,4.5,0.2c0.8,0.1,1.6,0.1,2.4,0.3c0.8,0.2,1.5,0.3,2.3,0.5
	c3,0.8,5.9,2,8.5,3.6c2.6,1.6,4.9,3.4,6.8,5.4c1,1,1.8,2.1,2.7,3.1c0.8,1.1,1.5,2.1,2.1,3.2c0.6,1.1,1.2,2.1,1.6,3.1
	c0.4,1,0.9,2,1.2,3c0.3,1,0.6,1.9,0.8,2.7c0.2,0.9,0.3,1.6,0.5,2.4c0.1,0.4,0.1,0.7,0.2,1c0,0.3,0.1,0.6,0.1,0.9
	c0.1,0.6,0.1,1,0.1,1.4C74,39.6,74,40,74,40c0.2,2.2-1.5,4.1-3.7,4.3s-4.1-1.5-4.3-3.7c0-0.1,0-0.2,0-0.3l0-0.4c0,0,0-0.3,0-0.9
	c0-0.3,0-0.7,0-1.1c0-0.2,0-0.5,0-0.7c0-0.2-0.1-0.5-0.1-0.8c-0.1-0.6-0.1-1.2-0.2-1.9c-0.1-0.7-0.3-1.4-0.4-2.2
	c-0.2-0.8-0.5-1.6-0.7-2.4c-0.3-0.8-0.7-1.7-1.1-2.6c-0.5-0.9-0.9-1.8-1.5-2.7c-0.6-0.9-1.2-1.8-1.9-2.7c-1.4-1.8-3.2-3.4-5.2-4.9
	c-2-1.5-4.4-2.7-6.9-3.6c-0.6-0.2-1.3-0.4-1.9-0.6c-0.7-0.2-1.3-0.3-1.9-0.4c-1.2-0.3-2.8-0.4-4.2-0.5l-2,0c-0.7,0-1.4,0.1-2.1,0.1
	c-0.7,0.1-1.4,0.1-2,0.3c-0.7,0.1-1.3,0.3-2,0.4c-2.6,0.7-5.2,1.7-7.5,3.1c-2.2,1.4-4.3,2.9-6,4.7c-0.9,0.8-1.6,1.8-2.4,2.7
	c-0.7,0.9-1.3,1.9-1.9,2.8c-0.5,1-1,1.9-1.4,2.8c-0.4,0.9-0.8,1.8-1,2.6c-0.3,0.9-0.5,1.6-0.7,2.4c-0.2,0.7-0.3,1.4-0.4,2.1
	c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.3-0.1,0.6-0.1,0.8c0,0.5-0.1,0.9-0.1,1.3C10,39.6,10,40,10,40z"
        transform="rotate(162.269 80 80)"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 40 40"
          to="360 40 40"
          dur="0.6s"
          repeatCount="indefinite"
        ></animateTransform>
      </path>
    </svg>-->
    <div
      v-if="showPerc"
      class="percentage"
    >
      <span
        class="percentage-text"
        v-text="percentageTxt"
      ></span>
    </div>
    <svg
      version="1.1"
      class="svg-loader"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 80 80"
      enable-background="new 0 0 80 80"
      xml:space="preserve"
    >
      <path d="M1.625,41.312c0-21.919,17.769-39.688,39.688-39.688c13.07,0,24.662,6.32,31.893,16.068C66.022,7.021,53.832,0,40,0C17.909,0,0,17.909,0,40c0,13.832,7.021,26.022,17.693,33.206C7.945,65.974,1.625,54.383,1.625,41.312z">
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 40 40"
          to="360 40 40"
          dur="0.6s"
          repeatCount="indefinite"
        ></animateTransform>
      </path>
    </svg>
    <!--<div class="spinner_container">
      <div class="nb-spinner"></div>
      <div class="circle_border_outside">
        <div class="circle_border">
          <div class="percentage">60%</div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
    name: 'CircleLoader',
    props: {
        size: { type: String, default: 'xs' },
        showPerc: { type: Boolean, default: false },
        percentage: { type: Number, default: 0 }
    },
    computed: {
        percentageTxt() {
            let perc = this.percentage;
            if (perc > 1)
                perc = 1;
            else if (perc < 0)
                perc = 0;
            return parseInt(perc * 100) + '%';
        }
    }
}
</script>

<style scoped lang="scss">
.circle-loader {
  position: relative;
  display: inline-block;
  overflow: hidden;

  .svg-loader {
    path {
      fill: $primary !important;
    }
  }

  .percentage {
    position: absolute;
    top: 8%;
    left: 8%;
    height: calc(100% - 16%);
    width: calc(100% - 16%);
    border-radius: 50%;
    background-color: #dddddd;
    text-align: center;
    display: flex;
    border-style: solid;
    border-width: 3px;
    border-color: #b7b7b7;

    .percentage-text {
      margin: auto;
      font-family: inherit;
      font-weight: 800;
      color: $primary;
    }
  }
  &.xs{
    height: 40px;
    width: 40px;

    .percentage-text {
      font-size: 10px;
    }
  }
  &.sm{
    height: 80px;
    width: 80px;

    .percentage-text {
      font-size: 20px;
    }
  }
  &.md{
    height: 120px;
    width: 120px;

    .percentage-text {
      font-size: 30px;
    }
  }
  &.lg{
    height: 160px;
    width: 160px;

    .percentage-text {
      font-size: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/configurator/comp/circleLoader.vue